
import { AlertTriangle, CheckCircle2 } from "lucide-react";

const ProblemSolution = () => {
  return (
    <section className="py-16 bg-gradient-to-r from-white via-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="bg-red-50/80 backdrop-blur-sm rounded-2xl p-8 border border-red-100 shadow-lg">
            <div className="flex items-center mb-4">
              <AlertTriangle className="h-6 w-6 text-red-500 mr-2" />
              <h2 className="text-2xl font-bold text-red-600">The Problem</h2>
            </div>
            <p className="text-lg text-gray-700 mb-6">
              Are you overpaying on processing fees? Most merchants lose 3-4% per sale—that's 
              <span className="font-bold text-red-600"> $10,000+ per year</span> on $300K revenue!
            </p>
          </div>
          
          <div className="bg-green-50/80 backdrop-blur-sm rounded-2xl p-8 border border-green-100 shadow-lg">
            <div className="flex items-center mb-4">
              <CheckCircle2 className="h-6 w-6 text-green-500 mr-2" />
              <h2 className="text-2xl font-bold text-green-600">Our Solution</h2>
            </div>
            <p className="text-lg text-gray-700 mb-6">
              We offer Cash Discount Programs to eliminate fees OR competitive traditional processing rates—
              <span className="font-bold text-green-600"> your choice, guaranteed savings</span>.
            </p>
          </div>
        </div>
        
        <div className="mt-12 bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl p-8 shadow-lg border border-gray-200">
          <h3 className="text-xl font-bold text-center mb-8">Processing Options Comparison</h3>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center bg-white rounded-xl p-6 shadow-md">
              <h4 className="font-semibold text-red-600 mb-4">Your Current Processor</h4>
              <ul className="space-y-2 text-gray-700">
                <li>• 3.5% - 4% per transaction</li>
                <li>• Monthly fees: $25-50</li>
                <li>• Setup fees: $99-299</li>
                <li>• Contract required</li>
              </ul>
            </div>
            <div className="text-center bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6 shadow-md border border-green-200">
              <h4 className="font-semibold text-green-600 mb-4">Cash Discount Program</h4>
              <ul className="space-y-2 text-gray-700">
                <li>• 0% processing fees*</li>
                <li>• Equipment rental only</li>
                <li>• Free setup</li>
                <li>• No contracts</li>
              </ul>
            </div>
            <div className="text-center bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-6 shadow-md border border-blue-200">
              <h4 className="font-semibold text-blue-600 mb-4">Traditional Processing</h4>
              <ul className="space-y-2 text-gray-700">
                <li>• Competitive rates below 3.5%</li>
                <li>• Transparent pricing</li>
                <li>• Free setup</li>
                <li>• No long-term contracts</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;
